export default __webpack_public_path__ + "static/media/15.258956e7.jpg";